import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DropDownFilterSettings} from "@progress/kendo-angular-dropdowns";
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {IntegracaoERPService} from "../../services/integracaoerp.service";

@Component({
  selector: 'app-form-integracaopedidos',
  templateUrl: './form-integracaopedidos.component.html',
  styleUrls: ['./form-integracaopedidos.component.scss']
})
export class FormIntegracaopedidosComponent implements OnInit {
  readonly MODO_ECLETICA_MESA = 'mesa';
  readonly MODO_ECLETICA_COMANDA = 'comanda';
  readonly MODO_ECLETICA_MESA_COMANDA = 'mesa_comanda';

  @Input() empresa: any = {};
  @ViewChild('frm', {}) frm:  any;
  lojas  = []
  mensagemErro: string;
  integracoes = [
    { id: 2, descricao: 'Ecletica' , sistema: 'ecletica', tipo: 'ERP' },
    { id: 7, descricao: 'Saipos', sistema: 'saipos', tipo: 'ERP'},
    { id: 9, descricao: 'GCOM ERP', sistema: 'gcom', tipo: 'ERP'},
    { id: 5, descricao: 'Menew', sistema: 'menew', tipo: 'ERP'},
    { id: 3, descricao: 'Tiny' , sistema: 'tiny', tipo: 'ERP' },
    { id: 8, descricao: 'Teknisa', sistema: 'teknisa', tipo: 'ERP'},
    { id: 10, descricao: 'TOTVS Chef', sistema: 'totvs', tipo: 'ERP'},
    { id: 6, descricao: 'Bluesoft', sistema: 'bluesoft', tipo: 'ERP'},
    { id: 4, descricao: 'RP Info', sistema: 'RPInfo', tipo: 'ERP'},
    { id: 11, descricao: 'Consumer', sistema: 'consumer', tipo: 'ERP'},
    { id: 12, descricao: 'COLIBRI', sistema: 'colibri', tipo: 'ERP'},
    //// { id: 10, descricao: 'Click Entregas' , sistema: 'clickentregas', tipo: 'Delivery' }
  ]
  integracaoDelivery: any = {
    configuracoesEspecificas: {}
  };
  salvando = false;
  removendo = false;
  carregandoLojas = false;
  confirmarRemover: any;
  chinas = []
  gendais = []
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains'
  };
  tinhaOutroPdvIntegrado = false;
  outroSistema: string;
  limpando: boolean;
  textoCopiado: string
  modosOperacaoEcletica = [
    {valor: this.MODO_ECLETICA_MESA, descricao: 'Mesa'},
    {valor: this.MODO_ECLETICA_COMANDA, descricao: 'Comanda'},
    {valor: this.MODO_ECLETICA_MESA_COMANDA, descricao: 'Mesa + Comanda'}
  ];
  constructor(private  empresaService: EmpresasService, private integracaoERPService: IntegracaoERPService) { }

  ngOnInit(): void {
    this.setIntegracaoDaEmpresa();

    this.empresaService.listeLojasChinnas().then( (resp) => {
      this.chinas = resp;
    })

    this.empresaService.listeLojasGendais().then( (resp) => {
      this.gendais = resp;
    })
  }

  setIntegracaoDaEmpresa(){
    if(this.empresa.integracaoDelivery){
      this.integracaoDelivery = Object.assign({}, this.empresa.integracaoDelivery )
      this.integracaoDelivery.integracao = this.integracoes.find( (integracao) => integracao.sistema ===  this.integracaoDelivery.sistema)

      if(this.integracaoDelivery.configuracoesEspecificas){
        Object.keys(this.integracaoDelivery.configuracoesEspecificas).forEach(key => {
          this.integracaoDelivery[key] = this.integracaoDelivery.configuracoesEspecificas[key]})
      }

      this.inicializeModoOperacaoEcletica();

      if(this.integradoConsumer()){
        const base = `https://${this.empresa.dominio}.meucardapio.ai`;
        this.integracaoDelivery.urlPolling = `${base}/apiconsumer/events:polling`
        this.integracaoDelivery.urlOrder = `${base}/apiconsumer/orders`
        this.integracaoDelivery.urlOrderStatus = `${base}/apiconsumer/orders/status`
        this.integracaoDelivery.urlOrderInfo = `${base}/apiconsumer/orders/infodetails`
      }
    }
  }

  onSubmit() {
    delete this.mensagemErro;

    if (this.frm.valid) {
      this.salvando = true;
      this.integracaoDelivery.sistema = this.integracaoDelivery.integracao.sistema;
      this.integracaoDelivery.tipo = this.integracaoDelivery.integracao.tipo;
      this.sincronizeModoOperacaoEcletica();
      this.empresaService.salveIntegracaoDelivery(this.empresa, this.integracaoDelivery).then( (integracao: any) => {
        this.empresa.integracaoDelivery = integracao;
        this.setIntegracaoDaEmpresa();
        this.integracaoDelivery.editar = false;
        this.salvando = false;
      }).catch( (erro) => {
        this.mensagemErro = erro;
        this.salvando = false
      })
    }
  }

  confirmeRemover() {
    this.confirmarRemover = true;
  }

  editarIntegracao(){
    this.integracaoDelivery.editar = true;
    this.carregueLojas();
  }

  canceleRemover() {
    this.confirmarRemover = false;
  }

  removerIntegracao() {

    this.removendo = true;

    this.empresaService.removaIntegracaoDelivery(this.empresa).then(  () => {
      this.removendo = false;
      delete  this.empresa.integracaoDelivery;
      this.integracaoDelivery = {}
    }).catch((erro) => {
      this.removendo = false;
      alert(erro)

    })

  }

  selecionouLojaGendai() {
    delete this.integracaoDelivery.unidadeChina;
  }

  selecionouLojaChina() {
    delete this.integracaoDelivery.unidadeGendai;
  }

  temToken(){
    if(!this.integracaoDelivery.integracao) return false;

    let sistema = this.integracaoDelivery.integracao.sistema;

    return sistema   === 'foodydelivery'  ||  sistema === 'tiny' ||  sistema === 'bluesoft' || sistema === 'teknisa';
  }

  integradoConsumer(){
    return this.integracaoDelivery?.sistema === 'consumer';
  }

  carregueLojas(){
    if( this.carregandoLojas || !this.integracaoDelivery.token ) return;

    if(!this.integracaoDelivery.configuracoesEspecificas || !this.integracaoDelivery.configuracoesEspecificas.grupo ) return;

    if(this.selecionarLoja() && !this.lojas.length){
      this.carregandoLojas = true;
      this.integracaoERPService.listeLojas(this.integracaoDelivery.token,
        this.integracaoDelivery.configuracoesEspecificas.grupo).then( (lojas) => {
        this.lojas = lojas;
        this.carregandoLojas = false;

        if( this.integracaoDelivery.loja)
          this.integracaoDelivery.loja = this.lojas.find((item: any) => item.lojaKey ===    this.integracaoDelivery.loja.id )

      }).catch((erro) => {
        this.carregandoLojas = false;
        alert('Nao foi possivel carregar lojas: ' + erro)
      })
    }
  }

  selecionarLoja(){
    if(!this.integracaoDelivery.integracao) return false;

    let sistema = this.integracaoDelivery.integracao.sistema;

    return  sistema === 'bluesoft';
  }

  selecionouLoja(){

  }

  alterouSistemaIntegrar(dados: any){
    if(!dados) return;

    this.integracaoDelivery.integracao = dados;

    if(dados.sistema === 'colibri' && !this.integracaoDelivery.modoOperacaoInLoco)
      this.integracaoDelivery.modoOperacaoInLoco = 'mesa';

    if(dados?.sistema === 'ecletica') {
      this.inicializeModoOperacaoEcletica();
    }

    if(dados.sistema === 'consumer') return;

    const pagamentoIntegradoComOutroSistema =
      this.empresa.formasDePagamento.find((item: any) => item.formaIntegrada && item.formaIntegrada.sistema !== dados.sistema)

    this.tinhaOutroPdvIntegrado = pagamentoIntegradoComOutroSistema != null;
    this.outroSistema = pagamentoIntegradoComOutroSistema?.formaIntegrada.sistema;


  }

  inicializeModoOperacaoEcletica() {
    if(this.integracaoDelivery?.integracao?.sistema !== 'ecletica') return;

    this.integracaoDelivery.configuracoesEspecificas = this.integracaoDelivery.configuracoesEspecificas || {};

    const modoOperacaoInLoco = this.integracaoDelivery.modoOperacaoInLoco
      || this.integracaoDelivery.configuracoesEspecificas.modoOperacaoInLoco
      || (this.integracaoDelivery.integrarComComandas || this.integracaoDelivery.configuracoesEspecificas.integrarComComandas
        ? this.MODO_ECLETICA_COMANDA
        : this.MODO_ECLETICA_MESA);

    this.integracaoDelivery.modoOperacaoInLoco = modoOperacaoInLoco;
    this.sincronizeModoOperacaoEcletica();
  }

  sincronizeModoOperacaoEcletica() {
    if(this.integracaoDelivery?.integracao?.sistema !== 'ecletica') return;

    this.integracaoDelivery.configuracoesEspecificas = this.integracaoDelivery.configuracoesEspecificas || {};

    const integrarComComandas = this.integracaoDelivery.modoOperacaoInLoco === this.MODO_ECLETICA_COMANDA
      || this.integracaoDelivery.modoOperacaoInLoco === this.MODO_ECLETICA_MESA_COMANDA;

    this.integracaoDelivery.integrarComComandas = integrarComComandas;
    this.integracaoDelivery.configuracoesEspecificas.integrarComComandas = integrarComComandas;
    this.integracaoDelivery.configuracoesEspecificas.modoOperacaoInLoco = this.integracaoDelivery.modoOperacaoInLoco;
  }

  descricaoModoOperacaoEcletica(modoOperacaoInLoco: string){
    const modo = modoOperacaoInLoco || (this.integracaoDelivery?.configuracoesEspecificas?.integrarComComandas
      ? this.MODO_ECLETICA_COMANDA
      : this.MODO_ECLETICA_MESA);

    switch (modo) {
      case this.MODO_ECLETICA_COMANDA:
        return 'Comanda';
      case this.MODO_ECLETICA_MESA_COMANDA:
        return 'Mesa + Comanda';
      case this.MODO_ECLETICA_MESA:
      default:
        return 'Mesa';
    }
  }

  limpeReferenciaAntigas() {
    this.limpando = true;

    this.empresaService.limpeReferenciasPdvAntigo().then(() => {
      this.limpando = false;
      this.tinhaOutroPdvIntegrado = null;
      this.outroSistema = null;
    }).catch((err: any) => {
      this.mensagemErro = err;
      this.limpando = false;
    })

  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.textoCopiado = val;
  }


}
